var map = {
	"./background.webp": 2500,
	"./background__result-layer1.webp": 8350,
	"./background__result-layer2.png": 1142,
	"./background__start01.webp": 3121,
	"./background__start02.webp": 3860,
	"./background__start03.webp": 6871,
	"./explanation.webp": 5339,
	"./percentage.svg": 1587,
	"./result__illust.webp": 3374,
	"./start__illust.webp": 1299,
	"./survey__illust.webp": 1589,
	"./title-result.webp": 6200,
	"./title.webp": 2266,
	"./torisan.webp": 190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3572;